import { opportunitySyncProfilesService } from '@/services/opportunity-sync-profiles.service';

/**
 * Caches the value-expression schema (context keys, types, operators) used to drive
 * autocomplete in the field-mapping editor. The schema is deployment-static, so we
 * fetch it once per session and keep it in memory. On failure we degrade silently —
 * the form still works without autocomplete.
 */

const initialState = () => ({
  schema: null,
  pending: false,
  loaded: false, // true once we have a usable schema in memory
});

const state = initialState();

let inFlight = null; // de-dupe concurrent loadSchema calls

const actions = {
  loadSchema({ commit, state }) {
    if (state.loaded) return Promise.resolve(state.schema);
    if (inFlight) return inFlight;
    commit('LOADING');
    inFlight = opportunitySyncProfilesService
      .getValueExpressionSchema()
      .then((schema) => {
        commit('LOADED', schema);
        inFlight = null;
        return schema;
      })
      .catch((err) => {
        commit('FAILED');
        inFlight = null;
        // eslint-disable-next-line no-console
        console.warn('Value-expression schema fetch failed — autocomplete disabled.', err);
        return null;
      });
    return inFlight;
  },
};

const mutations = {
  LOADING(state) {
    state.pending = true;
  },
  LOADED(state, schema) {
    state.schema = schema;
    state.pending = false;
    state.loaded = true;
  },
  FAILED(state) {
    state.pending = false;
    state.loaded = false;
  },
};

const getters = {
  schema: (s) => s.schema,
  contextKeys: (s) => (s.schema && s.schema.contextKeys) || [],
  types: (s) => (s.schema && s.schema.types) || {},
  operators: (s) => (s.schema && s.schema.operators) || [],
  loaded: (s) => s.loaded,
  pending: (s) => s.pending,
};

export const valueExpressionSchema = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
